/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_TIMELINE = gql`
  query GetTxnList($input: GetTxnListInput) {
    getTxnList(input: $input) {
      data {
        id
        action
        performedBy {
          firstName
          middleName
          lastName
        }
        type
        when
        payload
      }
    }
  }
`;
